import { CONFIG } from './config'

export const WORDS = [
  "nando",
  "eyebo",
  "cheat",
  "build",
  "uplay",
  "tmglc",
  "green",
  "speed",
  "match",
  "board",
  "right",
  "races",
  "grass",
  "xbone",
  "riolu",
  "block",
  "tmglo",
  "steer",
  "loser",
  "boost",
  "music",
  "dspad",
  "kacky",
  "timer",
  "ender",
  "hylis",
  "start",
  "coast",
  "crash",
  "slots",
  "teams",
  "ghost",
  "point",
  "items",
  "poles",
  "walls",
  "video",
  "input",
  "water",
  "pipes",
  "grand",
  "tmwii",
  "trial",
  "softy",
  "turns",
  "issue",
  "wheel",
  "steps",
  "admin",
  "skill",
  "worst",
  "rally",
  "flags",
  "htimh",
  "buggy",
  "world",
  "brake",
  "check",
  "local",
  "turbo",
  "beats",
  "scene",
  "wingo",
  "steam",
  "track",
  "holds",
  "drift",
  "score",
  "slide",
  "smurf",
  "mania",
  "black",
  "monka",
  "medal",
  "signs",
  "games",
  "nadeo",
  "times",
  "white",
  "dedis",
  "skids",
  "shoot",
  "sport",
  "jumps",
  "sight",
  "clubs",
  "nando",
  "eyebo",
  "cheat",
  "build",
  "uplay",
  "tmglc",
  "green",
  "speed",
  "match",
  "board",
  "right",
  "races",
  "grass",
  "xbone",
  "riolu",
  "block",
  "tmglo",
  "drive",
  "steer",
  "loser",
  "boost",
  "music",
  "dspad",
  "kacky",
  "timer",
  "ender",
  "hylis",
  "start",
  "coast",
  "crash",
  "slots",
  "teams",
  "ghost",
  "point",
  "items",
  "poles",
  "timmy",
  "mufat",
  "winke",
  "tmone",
  "lagon",
  "award",
  "royal",
  "donut",
  "accel",
  "joust",
  "reaby"
]

if (CONFIG.normalization) {
  WORDS.forEach((val, i) => (WORDS[i] = val.normalize(CONFIG.normalization)))
}

function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
}

if (CONFIG.shuffle) {
  shuffle(WORDS)
}
